import { Container, Header, SpaceBetween } from '@amzn/awsui-components-react';
import { CourseProps, RegistrationStatus } from '../../common/types';
import React from 'react';
import { createList } from '../../common/utils';
import { useAuthContext } from '../../components/auth/AuthContext';
import { MarkdownContent } from '../../components/MarkdownContent';

const ENROLLED_STATUSES = [RegistrationStatus.REGISTERED, RegistrationStatus.WAITLISTED];
const SKILLS_CENTERS_PROGRAM = 'Skills Centers';

const isUserAssociatedWithCourse = (userOrgId: string | undefined, userTeamIds: string[] | undefined, course: CourseProps): boolean => {
    const courseOrgIds = course.commercialPrivateCourseOrgIds;
    const courseTeamIds = course.teamIds;
    const orgMatch = !!userOrgId && !!courseOrgIds && courseOrgIds.includes(userOrgId);
    const teamMatch = !!userTeamIds && !!courseTeamIds && userTeamIds.some((id) => courseTeamIds.includes(id));
    return orgMatch || teamMatch;
};

export const CourseDetails = (props: { course: CourseProps }) => {
    const { user } = useAuthContext();
    const isEnrolled = props.course.registrationStatus && ENROLLED_STATUSES.includes(props.course.registrationStatus);
    const isAssociated = isUserAssociatedWithCourse(user.organizationId, user.teamIds, props.course);
    const isSkillsCenters = props.course.program === SKILLS_CENTERS_PROGRAM;
    const canViewNotes = isEnrolled || isAssociated || isSkillsCenters;

    return (
        <SpaceBetween size='s'>
            <Header>Course description</Header>
            <Container>
                <MarkdownContent content={props.course.courseDetails.description} />
            </Container>
            <Header>Objectives</Header>
            <Container>
                In this course, you will learn to:
                {createList(props.course.courseDetails.objectives)}
            </Container>
            <Header>Intended audience</Header>
            <Container>
                This course is intended for:
                {createList(props.course.courseDetails.audience)}
            </Container>
            <Header>Prerequisites</Header>
            <Container>
                <MarkdownContent content={props.course.courseDetails.prerequisites} />
            </Container>
            {canViewNotes && props.course.preWorkInstruction && (
                <>
                    <Header>Pre-work Instructions</Header>
                    <Container>
                        <MarkdownContent content={props.course.preWorkInstruction!} />
                    </Container>
                </>
            )}
            {canViewNotes && props.course.studentNotes && (
                <>
                    <Header>Notes</Header>
                    <Container>
                        <MarkdownContent content={props.course.studentNotes!} />
                    </Container>
                </>
            )}
        </SpaceBetween>
    );
};
